import React from 'react';
import { viewPressRelease } from '../../../api.services.js/others';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { Button, Container } from 'react-bootstrap';
import Head from 'next/head';

export const getServerSideProps = async (context) => {
    let identifier = context.query.release;
    const response = await viewPressRelease({identifier: identifier})    
    return {
      props: {response},
    };
  };
const PressReleaseDetails = (props) => {
  const router = useRouter()
  // const getData = async ()=>{
  //   const response = await viewPressRelease({identifier: router.query.release})    
  // }
  // useEffect(()=>{getData()},[])
  // console.log(props)
 
  const pressRelease = props?.response?.data?.view_press_release;
  

  return (
    <>
    <Head>
    <meta charset='utf-8'/>
    <title>{pressRelease?.title}</title>
    <meta name='title' content={pressRelease?.title}/>
    <meta name ='description' content={pressRelease?.meta_description}/>
    <meta name='keywords' content={pressRelease?.meta_keywords} />
    </Head>
     <div className='press_release_detail_page'>
      <Container>
      <h1 className='productpage_title'>{pressRelease?.title}</h1>
      <p>Date: {pressRelease?.date}</p>
      <p>Authors: {pressRelease?.authors}</p>
      <img src={pressRelease?.img} alt={pressRelease?.title} />
      <div dangerouslySetInnerHTML={{ __html: pressRelease?.content }}></div>
      <Button style={{float:"right", background:"grey", border:"none"}} onClick={()=>router.back()}>Back</Button>
      </Container>
     </div>
    </>
  );
};

export default PressReleaseDetails;
